import { render, staticRenderFns } from "./Lection.vue?vue&type=template&id=8cd40904&"
import script from "./Lection.vue?vue&type=script&lang=js&"
export * from "./Lection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports